import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestFormHeader } from '@Types/index';

interface AttendanceRequestState {
  attendanceRequest: RequestFormHeader;
  attendanceLocation: 'H' | 'P';
}

const initialState: AttendanceRequestState = {
  attendanceRequest: getDefaultRequestState(),
  attendanceLocation: 'H',
};

const attendanceRequestSlice = createSlice({
  name: 'attendanceRequest',
  initialState,
  reducers: {
    setAttendanceRequest: (
      state: AttendanceRequestState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.attendanceRequest = getDefaultRequestState();
      } else {
        state.attendanceRequest = payload;
      }
    },
    setAttendanceLocation: (
      state: AttendanceRequestState,
      action: PayloadAction<'H' | 'P'>
    ) => {
      state.attendanceLocation = action.payload;
    },
  },
});

const { actions } = attendanceRequestSlice;

export const attendanceRequestActions = {
  ...actions,
};

export default attendanceRequestSlice;
